<template>
  <div class="login_container">
    <div class="login_box">
      <div data-track-text="关闭" aria-label="关闭" style="position: absolute;left: 99%;top: -25px;" @click="onCloseBlur">
        <div class="closes"></div>
      </div>
      <div class="image_box">
        <img v-if="code===undefined||code==='undefined'||code===''" src="../assets/register.png" alt=""/>
        <img v-if="code==='haoyi'" src="../assets/regis-two.png" alt=""/>
      </div>
      <div class="header">
        <span data-track-text="机构密码登录页签" aria-label="机构密码登录页签" @click="headerPassClick" style="margin: 0;font-family: Noto Sans S Chinese !important;"
              :class="headerPass">密码登录</span>
        <span style="margin: 0 22px;font-weight: 100;font-size: 24px !important;">|</span>
        <span data-track-text="机构快捷登录页签" aria-label="机构快捷登录页签" @click="headerPhoneClick" style="margin: 0;font-family: Noto Sans S Chinese !important;"
              :class="headerPhone">快捷登录</span>
      </div>
      <hr :class="headerHr" style="
      background-color: var(--primary-dark);
      width: 40px;
    border: 1px solid var(--primary-dark);
    margin-block-end: 1em;
    margin-top: 8px;
    padding: 0px;
    margin-bottom: 20px;
    "/>
      <el-form v-show="isActive" label-width="0" class="login_form" :model="from" :rules="login_rules"
               ref="loginRef">
        <el-form-item prop="username">
          <el-input placeholder="请输入账号/邮箱/手机号" v-model="from.username"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input placeholder="请输入密码" type="password" v-model="from.password"
          ></el-input>
        </el-form-item>
        <el-form-item prop="validate">
          <el-input placeholder="请输入4位验证码" v-model="from.validate" style="border-radius: 3px;width: 279.8px"
          ></el-input>
          <img style="border-radius: 3px;float: right;width: 133.5px;height: 44px" :src="qrcodeUrl"
               alt="验证码加载失败..."
               data-track-text="刷新图形验证码"
               aria-label="刷新图形验证码"
               @click="getValicode"/>
        </el-form-item>
        <div style="color: #df2525;font-size: 14px;font-family: Noto Sans S Chinese !important;">{{ messages }}
        </div>
        <el-form-item style="margin-bottom: 0;margin-top: -10px;">
          <div style="float: left;cursor:pointer;font-family: Noto Sans S Chinese !important; "
               data-track-text="机构忘记密码"
               aria-label="机构忘记密码"
               @click="resetPassword">忘记密码?
          </div>
          <div style="float: right;cursor:pointer;color: var(--primary-dark);font-family:Noto Sans S Chinese !important;
font-weight:400;" data-track-text="机构快捷注册" aria-label="机构快捷注册" @click="toRegister">快捷注册
          </div>
        </el-form-item>
        <el-form-item class="login_button">
          <el-button type="primary" data-track-text="机构密码登录" aria-label="机构密码登录" @click="submitLoginFrom()">登录</el-button>
        </el-form-item>
        <div style="color: #999999;font-size: 14px;margin-top: 60px;
        font-family: Noto Sans S Chinese !important;text-align: center;">{{ ipTitel }}
        </div>
        <div style="font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #999999;
text-align: center;
    margin-top: 12px;">
          <hr class="third-party-divider" style="
    width: 150px;
    border-top: 1px solid rgb(203, 203, 203);
    margin-top: 13px;
    position: absolute;
    margin-bottom: 0px;
    width: 420px;
    left: 50%;
    transform: translate(-50%, -3px);
    z-index: 0;">
          <span style="position: relative;
    background-color: white;
    padding: 0px 8px;">第三方登录</span>
        </div>
        <div style="text-align: center;margin-top: -8px;">
          <img src="../assets/qq_logo.png" alt="" data-track-text="QQ登录" aria-label="QQ登录" width="44" height="44" style="padding: 25px;cursor: pointer;"
               @click="loginByQQ">
          <img src="../assets/wx_logo.png" alt="" data-track-text="微信登录" aria-label="微信登录" width="44" height="44" style="padding: 25px;cursor: pointer;"
               @click="loginByWX">
        </div>
      </el-form>
      <el-form v-show="!isActive" label-width="0" class="login_form" :model="phoneFrom" :rules="phone_login_rules"
               ref="phoneLoginRef">
        <el-form-item prop="phone">
          <el-input placeholder="请输入手机号" v-model="phoneFrom.phone"></el-input>
        </el-form-item>
        <el-form-item prop="validate">
          <el-input placeholder="请输入4位验证码" v-model="phoneFrom.validate" style="width: 279.8px"
          ></el-input>
          <img style="float: right;width: 133.5px;height: 44px" :src="qrcodeUrl" alt="验证码加载失败..."
               data-track-text="刷新图形验证码"
               aria-label="刷新图形验证码"
               @click="getValicode"/>
        </el-form-item>
        <el-form-item prop="phoneValidate">
          <el-input placeholder="请输入6位验证码" v-model="phoneFrom.phoneValidate" style="width: 279.8px"
          ></el-input>
          <div class="timeButton" v-show="Verification" data-track-text="机构获取动态密码" aria-label="机构获取动态密码" @click="handleTimeClick">获取动态密码</div>
          <div class="timeButtonClick" v-show="!Verification">{{ timers }}秒后重新获取</div>
        </el-form-item>
        <div style="color: #df2525;font-size: 14px;font-family: Noto Sans S Chinese !important;">{{ messages }}
        </div>
        <el-form-item style="margin-bottom: 0;margin-top: -10px;">
          <div style="float: left;cursor:pointer;font-family: Noto Sans S Chinese !important;"
               data-track-text="机构忘记密码"
               aria-label="机构忘记密码"
               @click="resetPassword">忘记密码?
          </div>
          <div style="float: right;cursor:pointer;color: var(--primary-dark);font-family:Noto Sans S Chinese !important;
font-weight:400;" data-track-text="机构快捷注册" aria-label="机构快捷注册" @click="toRegister">快捷注册
          </div>
        </el-form-item>
        <el-form-item class="login_button">
          <el-button type="primary" data-track-text="机构手机号快捷登录" aria-label="机构手机号快捷登录" @click="submitPhoneLoginFrom()">登录</el-button>
        </el-form-item>
        <div style="color: #999999;font-size: 14px;margin-top: 60px;
        font-family: Noto Sans S Chinese !important;text-align: center;">{{ ipTitel }}
        </div>
        <div style="font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #999999;
text-align: center;
    margin-top: 12px;">
          <hr class="third-party-divider" style="
    width: 150px;
    border-top: 1px solid rgb(203, 203, 203);
    margin-top: 13px;
    position: absolute;
    margin-bottom: 0px;
    width: 420px;
    left: 50%;
    transform: translate(-50%, -3px);
    z-index: 0;">
          <span style="position: relative;
    background-color: white;
    padding: 0px 8px;">第三方登录</span>
        </div>
        <div style="text-align: center;margin-top: -8px;">
          <img src="../assets/qq_logo.png" alt="" data-track-text="QQ登录" aria-label="QQ登录" width="44" height="44" style="padding: 25px;cursor: pointer;"
               @click="loginByQQ">
          <img src="../assets/wx_logo.png" alt="" data-track-text="微信登录" aria-label="微信登录" width="44" height="44" style="padding: 25px;cursor: pointer;"
               @click="loginByWX">
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import {
  getAppIdRequest,
  loginRequest,
  valicodeRequest,
  userIpRequest,
  authServiceClient,
  checkPhoneRequest,
  phoneCodeRequest,
  phoneLoginRequest, checkUserNameRequest
} from '../tools/api/auth-api'

export default {
  name: "LoginTwo",
  methods: {
    getUrlParameter(route) {
      //decodeURIComponent() 函数可对 encodeURIComponent() 函数编码的 URI 进行解码。
      let url = decodeURIComponent(route).split('?');
      url = url[url.length - 1];
      let obj = {};
      url.split('&').map((query) => {
        let temp = query.split('=');
        obj[temp[0]] = temp[1];
      });
      return obj;
    },
    loginByQQ() {
      let request = getAppIdRequest;
      request.setType("qq")
      const CODE_KEY = 'code';
      let metadata;
      if (localStorage.getItem(CODE_KEY)) {
        metadata = {[CODE_KEY]: localStorage.getItem(CODE_KEY)}
      } else {
        metadata = {}
      }
      authServiceClient.getAppId(request, metadata).then(res => {
        let state = res.getState();
        if (state === "400") {
          return
        }
        let appId = res.getAppId();
        window.open('https://graph.qq.com/oauth2.0/authorize?client_id=' + appId +
            '&redirect_uri=' + encodeURIComponent("https://wesitrans.com/index") +
            '&response_type=code&scope=get_user_info&state=' + state)
      }).catch(err => {

      })
    },
    loginByWX() {
      let request = getAppIdRequest;
      request.setType("wx")
      const CODE_KEY = 'code';
      let metadata;
      if (localStorage.getItem(CODE_KEY)) {
        metadata = {[CODE_KEY]: localStorage.getItem(CODE_KEY)}
      } else {
        metadata = {}
      }
      authServiceClient.getAppId(request, metadata).then(res => {
        let state = res.getState();
        if (state === "400") {
          return
        }
        let appId = res.getAppId();
        window.open('https://open.weixin.qq.com/connect/qrconnect?appid=' + appId +
            '&redirect_uri=' + encodeURIComponent("https://wesitrans.com") +
            '&response_type=code&scope=snsapi_login&state=' + state + '#wechat_redirect')
      }).catch(err => {

      })
    },
    validatePhoneCode(rule, value, callback) {
      if (!this.isLogin) {
        callback()
        return
      }
      if (value === null || value === undefined || value === "") {
        callback(new Error('请输入手机验证码'))
        return;
      }
      if (value.length > 6 || value.length < 6) {
        callback(new Error('请输入6位手机验证码'))
        return;
      }
      callback()
    },
    handleTimeClick() {
      this.$refs.phoneLoginRef.validate((valid) => {
        if (!valid) {
          return;
        }
        const that = this;
        let request = phoneCodeRequest;
        request.setCode(this.phoneFrom.validate)
        request.setPhone(this.phoneFrom.phone)
        const CODE_KEY = 'code';
        let metadata;
        if (localStorage.getItem(CODE_KEY)) {
          metadata = {[CODE_KEY]: localStorage.getItem(CODE_KEY)}
        } else {
          metadata = {}
        }
        authServiceClient.sendPhoneCode(request, metadata)
            .then(res => {
              if (res.getStatus()) {
                that.messages = "";
                that.Verification = false;
                this.auth_timer = setInterval(() => {
                  that.timers--;
                  if (that.timers <= 0) {
                    that.Verification = true;
                    that.timers = 60;
                    clearInterval(that.auth_timer)
                  }
                }, 1000)
                return;
              }
              that.getValicode();
              that.messages = "验证码错误"
              that.Verification = true;
              that.timers = 60;
            }).catch(err => {
          that.getValicode();
          that.messages = "手机验证码发送失败"
          that.Verification = true;
          that.timers = 60;
        });
      });
    },
    validateName(rule, value, callback) {
      if (/.*[\u4e00-\u9fa5]+.*$/.test(value)) {
        callback(new Error('用户名不能含有汉字'));
        return;
      }
      if (/.*[`~!#$^&*()=|{}':;',\[\]<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]+.*$/.test(value)) {
        callback(new Error('用户名不能包含特殊字符'));
        return;
      }
      let request = checkUserNameRequest;
      request.setUsername(value);
      authServiceClient.checkUserName(request, null).then(res => {
        if (res.getStatus() === 1) {
          callback(new Error('账号有误'))
          return;
        }
        if (res.getStatus() === 3) {
          callback(new Error('账号未注册'))
          return;
        }
        if (res.getStatus() === 2) {
          callback(new Error('账号已被冻结'))
          return;
        }
        callback()
      }).catch(err => {
        callback(new Error('校验出错'));
      })
    },
    validatePhone(rule, value, callback) {
      let request = checkPhoneRequest;
      request.setPhone(value);
      authServiceClient.checkPhone(request, null).then(res => {
        if (res.getStatus() === 1) {
          callback(new Error('手机号有误'))
          return;
        }
        if (res.getStatus() === 3) {
          callback(new Error('手机号未注册'))
          return;
        }
        if (res.getStatus() === 2) {
          callback(new Error('账号已被冻结'))
          return;
        }
        callback()
      }).catch(err => {
        callback(new Error('校验出错'));
      })
    },
    headerPassClick() {
      this.headerPass = 'headerMax';
      this.headerPhone = 'headerMin';
      this.headerHr = 'headerLeft';
      this.isActive = true;
    },
    headerPhoneClick() {
      this.headerPass = 'headerMin';
      this.headerPhone = 'headerMax';
      this.headerHr = 'headerRight';
      this.isActive = false;
    },
    getUserIp() {
      authServiceClient.getUserIp(userIpRequest).then(res => {
        this.ipTitel = res.getIpTitle()
      }).catch(err => {
      })
    },
    onCloseBlur() {
      parent.window.location.reload();
    },
    resetPassword() {
      this.$router.push('/resetPasswordTwo?code='+this.code)
    },
    toRegister() {
      this.$router.push("/registerTwo?code="+this.code)
    },
    getValicode() {
      const CODE_KEY = 'code';
      let metadata;
      if (localStorage.getItem(CODE_KEY)) {
        metadata = {[CODE_KEY]: localStorage.getItem(CODE_KEY)}
      } else {
        metadata = {}
      }
      authServiceClient.getValicode(valicodeRequest, metadata).then(res => {
        this.qrcodeUrl = 'data:image/gif;base64,' + res.toObject().valicodeImage;
      })
    },
    submitPhoneLoginFrom() {
      this.isLogin = true;
      this.$refs.phoneLoginRef.validate((valid) => {
        if (!valid) {
          return;
        }
        let request = phoneLoginRequest;
        request.setPhone(this.phoneFrom.phone);
        request.setPhoneCode(this.phoneFrom.phoneValidate);
        const TOKEN_KEY = 'token';
        const CODE_KEY = 'code';
        let metadata;
        if (localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else if (localStorage.getItem(TOKEN_KEY) && !localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }
        } else if (!localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else {
          metadata = {}
        }
        authServiceClient.phoneLogin(request, metadata).then(res => {
          if (res.getStatus() === 0) {
            parent.window.location.reload();
            return;
          }
          this.messages = res.getMessage();
          this.getValicode();
          this.isLogin = false;
        }).catch(err => {
          if (err && err.code === 5) {
            this.$router.push("/loginTwo")
          }
          this.isLogin = false;
        })
      });
      this.isLogin = false;
    },
    submitLoginFrom() {
      const that = this;
      this.$refs.loginRef.validate((valid) => {
        if (!valid) {
          return false;
        }
        let request = loginRequest;
        request.setUsername(that.from.username);
        request.setPassword(that.from.password);
        request.setValicode(that.from.validate);
        const TOKEN_KEY = 'token';
        const CODE_KEY = 'code';
        let metadata;
        if (localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else if (localStorage.getItem(TOKEN_KEY) && !localStorage.getItem(CODE_KEY)) {
          metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
          }
        } else if (!localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
          metadata = {
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          }
        } else {
          metadata = {}
        }
        authServiceClient.userLogin(request, metadata).then(res => {
          if (res.getStatus() === 0) {
            parent.window.location.reload();
            return;
          }
          that.messages = res.getMessage();
          this.getValicode();
        }).catch(err => {
          if (err && err.code === 5) {
            this.$router.push("/loginTwo")
          }
        })
      })
    }
  },
  data() {
    return {
      code: '',
      isLogin: false,
      auth_timer: null,
      timers: 60,
      Verification: true,
      isActive: true,
      headerPass: 'headerMax',
      headerPhone: 'headerMin',
      activeName: 'passLogin',
      headerHr: 'headerLeft',
      ipTitel: '',
      from: {
        username: "",
        password: "",
        validate: ""
      },
      phoneFrom: {
        phone: "",
        validate: "",
        phoneValidate: ""
      },
      phone_login_rules: {
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1[0-9]{10}$/, message: "请输入合法手机号", trigger: "blur"},
          {validator: this.validatePhone, trigger: 'blur'}
        ],
        validate: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {min: 4, max: 4, message: '请输入4位验证码', trigger: 'blur'}
        ],
        phoneValidate: [
          {validator: this.validatePhoneCode, trigger: 'blur'}
        ]
      },
      login_rules: {
        username: [
          {required: true, message: '请输入账号/邮箱/手机号', trigger: 'blur'},
          {min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur'},
          {validator: this.validateName, trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur'}
        ],
        validate: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {min: 4, max: 4, message: '请输入4位验证码', trigger: 'blur'}
        ]
      },
      qrcodeUrl: "",
      messages: ''
    }
  },
  created() {
    this.getValicode();
    this.getValicode();
    this.getUserIp();
    this.code = this.getUrlParameter(this.$route.fullPath).code;
  },
  destroyed() {
    clearInterval(this.auth_timer)
  }
}
</script>

<style lang="less" scoped>
.timeButton {
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
  padding: 10px 20px;
  width: 94px;
  height: 24px;
  float: right;
  background-color: var(--primary-light);
  border: 1px solid var(--primary-alpha-22);
  font-size: 14px;
  font-weight: 400;
  font-family: Noto Sans S Chinese !important;
  line-height: 1.7;
  text-align: center;
  color: var(--primary-dark);
}

.timeButtonClick {
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
  padding: 10px 20px;
  border: 0px solid #000;
  width: 94px;
  height: 24px;
  float: right;
  background-color: var(--primary-dark);
  font-size: 14px;
  font-weight: 400;
  font-family: Noto Sans S Chinese !important;
  line-height: 1.7;
  text-align: center;
  color: #ffffff;
}

.headerLeft {
  margin-left: 234px;
}

.headerRight {
  margin-left: 357px;
}

.headerMin {
  font-size: 18px !important;
  font-family: Noto Sans S Chinese;
  font-weight: 400;
  color: #333333;
}

.headerMax {
  font-size: 24px !important;
  font-family: Noto Sans S Chinese;
  font-weight: 400;
  color: #333333;
}

.closes {
  background-image: url("../assets/closeone.png");
  background-size: 32px;
  height: 32px;
  width: 32px;
}

.closes:hover {
  background-image: url("../assets/closetwo.png");
}

/deep/ .el-input__inner {
  height: 44px !important;
  font-size: 16px;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}

/deep/ .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
  border-color: #fbafaf !important;
}

/deep/ .el-form-item__error {
  font-size: 14px;
  color: rgba(223, 37, 37, 1);
}

/deep/ .el-form-item {
  margin-bottom: 21px;
}

.login_container {
  min-width: 948px !important;
  height: 501px !important;;
  width: 948px !important;
  background-color: #feffff;
}

.login_box {
  width: 615px;
  height: 501px;
  background-color: #ffffff;
  border-radius: 3px;
  position: absolute;
  left: 35%;
  /*top: 20%;*/
  box-shadow: 0 0 10px #dddddd;

  .image_box {
    position: absolute;
    transform: translate(-100%);
    background-color: #ffffff;
    border-radius: 3px;
    box-shadow: 0 0 1px #dddddd;
    width: 333px;
    height: 501px;

    img {
      width: 100%;
      height: 501px;
    }
  }

  .login_button {
    font-family: Noto Sans S Chinese !important;

    .el-button {
      font-family: Noto Sans S Chinese !important;
      position: absolute;
      width: 100%;
      background-color: var(--primary-dark);
      height: 48px;
      font-size: 20px;
    }
  }

  .header {
    font-size: 22px;
    margin-left: 49%;
    transform: translate(-30%);
    margin-top: 20px;

    span {
      margin: 0;
      font-size: 22px;
      font-family: Noto Sans S Chinese;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      cursor: pointer;
    }
  }

  .login_form {
    width: 100%;
    position: absolute;
    padding-left: 15.448%;
    padding-right: 15.448%;
    box-sizing: border-box;
  }
}
</style>
<style lang="less" scoped>
@media (max-width: 768px) {
  .login_container {
    width: 100% !important;
    min-width: 0 !important;
    height: auto !important;
    min-height: 100vh;
    padding: 16px;
    overflow-x: hidden;
    background: #f3f7fb;
    box-sizing: border-box;
  }

  .login_box {
    position: relative !important;
    left: auto !important;
    width: 100% !important;
    max-width: 520px;
    height: auto !important;
    min-height: calc(100vh - 32px);
    margin: 0 auto;
    padding: 18px 16px 28px;
    border-radius: 14px;
    box-sizing: border-box;
  }

  .image_box {
    display: none;
  }

  .closes {
    display: none;
  }

  .header {
    width: 100% !important;
    margin: 0 0 16px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: none !important;
    font-size: 18px !important;
  }

  .header span,
  .header h3 {
    font-size: 18px !important;
  }

  .login_form {
    position: relative !important;
    width: 100% !important;
    padding: 0 !important;
    box-sizing: border-box;
  }

  .login_form /deep/ .el-form-item,
  .login_form /deep/ .el-input {
    width: 100% !important;
    box-sizing: border-box;
  }

  .login_form /deep/ .el-input[style*="279.8px"] {
    width: calc(100% - 122px) !important;
  }

  .login_form img[aria-label="刷新图形验证码"] {
    width: 114px !important;
    object-fit: cover;
  }

  .timeButton,
  .timeButtonClick {
    width: 114px !important;
    padding: 0 4px !important;
    font-size: 12px !important;
    text-align: center;
  }

  .login_button /deep/ .el-button {
    position: static !important;
    width: 100% !important;
    height: 44px !important;
    font-size: 16px !important;
  }

  .third-party-divider {
    left: 0 !important;
    width: 100% !important;
    max-width: 100%;
    transform: translateY(-3px) !important;
  }
}
</style>
